import { applyMiddleware, createStore, combineReducers, compose } from 'redux';
import { reduxReactRouter } from 'redux-router';
import { browserHistory } from 'react-router';

import reducers from './ggApp/reducers';
import middlewares from './_middlewares';

const devtoolsComposeFunction = '__REDUX_DEVTOOLS_EXTENSION_COMPOSE__';

export default function configureStore(initialState) {
    const composeEnhancers =
        typeof window === 'object' && window[devtoolsComposeFunction]
            ? window[devtoolsComposeFunction]({})
            : compose;
    const middleware = composeEnhancers(
        applyMiddleware(...middlewares),
        reduxReactRouter({ createHistory: () => browserHistory }),
    );

    const store = middleware(createStore)(combineReducers(reducers), initialState);

    if (module.hot) {
        // Enable Webpack hot module replacement for reducers
        module.hot.accept('./ggApp/reducers', () => {
            import('./ggApp/reducers').then(({ default: nextRootReducer }) => {
                store.replaceReducer(nextRootReducer);
            });
        });
    }

    return store;
}
